/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProjectsModel {
    getFixupPrototypeFunction() { return ProjectsModel.fixupPrototype; }

    static newInstance(model: Partial<ProjectsModel>): ProjectsModel {
        let obj = Object.assign(new ProjectsModel(), model);
        ProjectsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProjectsModel>): ProjectsModel {
        if (!model) return null;
        return ProjectsModel.newInstance(<ProjectsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProjectsModel) {
        if (!obj) return;

        models.ProjectsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProjectsModel): boolean {
        Object.setPrototypeOf(obj, ProjectsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the tenant
     */
    tenant_name: string;

    /**
     * ID of the tenant
     */
    tenant_id: string;

}
